import React from "react";
import { CalendarClock, Gift } from "lucide-react";

export const StockingSpotlight = ({ stocking, picks, onOpen }) => (
  <div className="mb-8 grid sm:grid-cols-[220px_1fr] spooky-card border-4 border-candy-gold rounded-2xl overflow-hidden shadow-glow-orange" data-testid="stocking-spotlight">
    <img src={stocking.image} alt={stocking.name} className="h-56 sm:h-full w-full object-cover" />
    <div className="p-6 flex flex-col">
      <h3 className="font-spooky text-3xl text-candy-cream">{stocking.name}</h3>
      <p className="mt-2 text-sm text-candy-cream/80 font-medium flex-1">
        Fill a red velvet stocking with any {picks} stuffers below — mix and match however you like.
      </p>
      <span className="mt-3 font-display text-4xl text-candy-gold" data-testid="stocking-price">${stocking.price.toFixed(2)}</span>
      {stocking.coming_soon ? (
        <button disabled data-testid="stocking-coming-soon-btn" className="mt-3 w-full bg-candy-night font-extrabold uppercase text-sm tracking-wider py-3.5 border-4 border-candy-gold rounded-xl cursor-not-allowed flex items-center justify-center gap-2">
          <CalendarClock className="h-5 w-5" /> Coming Soon · Opens Nov 1
        </button>
      ) : (
        <button onClick={onOpen} data-testid="open-stocking-btn" className="mt-3 w-full bg-candy-pink text-white font-extrabold uppercase text-sm tracking-wider py-3.5 border-4 border-black rounded-xl shadow-glow-orange hover:-translate-y-0.5 transition-transform flex items-center justify-center gap-2">
          <Gift className="h-5 w-5" /> Build Your Stocking
        </button>
      )}
    </div>
  </div>
);
